export const COOKIE_NAME = 'tiketti-cookie-allow';
export const LANG_PREFERENCE = 'tiketti-lang-preference';
